/** @jsxImportSource @emotion/react */
import type { PropsWithChildren } from 'react';
import React, { forwardRef } from 'react';
import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';
import type { IPropsWithTestId } from '../../../constants/data-element-tracking-ids';
import { ELEMENT_ID_DATA_ATTRIBUTE } from '../../../constants/data-element-tracking-ids';

// https://react.dev/warnings/special-props
// eslint-disable-next-line react/display-name
export const BoxWithId = forwardRef<
HTMLDivElement | undefined,
PropsWithChildren<BoxProps & Partial<IPropsWithTestId>>
>(({ children, dataElementId, ...props }, ref) => (
  <Box
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    ref={ref}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...(dataElementId ? { [ELEMENT_ID_DATA_ATTRIBUTE]: dataElementId } : {})}
  >
    {children}
  </Box>
));
